import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

class ReferenceShort extends React.Component {
    render() {
        let showed = 0;
        
        if(this.state.refs.length < 1) return null;
        return (
                <div className="contentTextContainer">
                    <h2>Zkušenosti některých našich&nbsp;studentů</h2>
                    {this.state.refs.map((ref, index) => {
                        if(showed >= this.state.showRefs) return null;

                        let textLength = ref.text.length;
                        let text = ref.text;
                        let showMore = !ref.showed;
                        if(showMore && textLength > 250) {
                            var tmp = document.createElement("DIV");
                            tmp.innerHTML = text;
                            text = tmp.textContent || tmp.innerText || "";
                            text = text.substr(0, 250);
                            text = '<p>'+text+'</p>';
                        } else {
                            showMore = false;
                        }
                        showed++;
                        return <blockquote key={ref.reference_id} >
                            <div dangerouslySetInnerHTML={{ __html: text }}></div>
                            {ref.from_name.length > 0 && !showMore && <p><b>{ref.from_name}</b></p>}
                            {showMore && 
                                <a href="#" className="more" onClick={(e) => { e.preventDefault(); this.showRef(index); }}>Celá recenze</a>
                            }
                        </blockquote>
                    })}
                    {this.state.refs.length > this.state.showRefs ?
                        <a href="#" className="btn-more" onClick={this.showMore}>Zobrazit další reference</a>
                    :
                        <a href={this.state.moreUrl} className="btn-more" target="_blank">Zobrazit další reference</a>
                    }
                </div>
            );
    }

    constructor(props) {
        super(props);

        this.state = {
            refs: [],
            showRefs: 3,
            moreStep: 3,
            moreUrl: ""
        }
    }

    componentDidMount() {
        axios.get("/", {params: {action: "getRefs", pageId: window.pageId, schoolId: window.schoolId ? window.schoolId : null}})
            .then((response) => {
                
                this.setState({ refs: response.data.items, moreUrl: response.data.moreUrl });
            })
            .catch((error) => {
                
            });
    }

    showRef = (index) => {
        const refs = [...this.state.refs];
        refs[index].showed = true;

        this.setState({ refs });
    }

    showMore = (e) => {
        e.preventDefault();
        this.setState({ showRefs: this.state.showRefs + this.state.moreStep });
    }

}


ReactDOM.render(
    <ReferenceShort />,
    document.getElementById('reference-short')
);


// WEBPACK FOOTER //
// ./resources/reference-short.js